<template lang="pug">
  main
    NavBarSoporte
    Loader(v-show="isLoading")
    ModalEstado(v-show="modalStatus" :config="configModal" @padre:select="checarModalAutCompra")
    ModalAutorizar(v-show="modalStatusAut" @padre:select="checarModalAutCompra")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title {{ areaStr }}&nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-6(v-show="isAdmin")
            input#allH.is-checkradio.is-black(type='radio', value='ALL' v-model='queryUbicacion' checked='checked')
            label.is-size-6(for='allH') Todos
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='queryUbicacion')
            label.is-size-6(for='tpaH') TPA
            input#irgeH.is-checkradio.is-black(type='radio', value='IRGE' v-model='queryUbicacion')
            label.is-size-6(for='irgeH') IRGE
            input#eb04H.is-checkradio.is-black(type='radio', value='EB04' v-model='queryUbicacion')
            label.is-size-6(for='eb04H') EB04
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='queryUbicacion')
            label.is-size-6(for='corpH') CORP.
            input#ductoH.is-checkradio.is-black(type='radio', value='LPGD' v-model='queryUbicacion')
            label.is-size-6(for='ductoH') DUCTO
          .column.is-1(v-show="isAdmin")
            .field
              input#isPend.is-checkradio(type='checkbox' v-model='showPendientes')
              label.is-size-6(for='isPend') Pendientes
          .column.is-offset-6.is-1(v-show="!isAdmin")
            .field
              input#isPend.is-checkradio(type='checkbox' v-model='showPendientes')
              label.is-size-6(for='isPend') Pendientes
          .column.is-offset-1.is-3(v-show="isAdmin")
            .field
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Buscar por Serie|Solicita',
                  v-model="queryFilter",
                )
          .column.is-offset-1.is-3(v-show="!isAdmin")
            .field
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Buscar por Serie|Solicita',
                  v-model="queryFilter",
                )
          .column.is-1
            router-link.a.button.is-black(to="/Soporte/Nuevo")
              | Nuevo
        .columns(v-show="tickets.length > 0")
          .column.is-12.has-text-centered
            Tb_Tickets(:tickets="ticketsShow" @showModalCompra="showModalSolCompra" @printReport="printReport")
        .columns(v-show="tickets.length < 1")
          .column.is-half.is-offset-one-quarter.has-text-centered
            .notification.is-danger
              button.delete
              |   No hay registros aún.
        .columns.column-blanco
</template>


<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarSoporte from '@/components/soporte_Componentes/NavBarSoporte.vue'
import ticketServices from '@/services/soporte/tickets'
import ReportesServices from '@/services/reportes/reportes'
import ModalEstado from '@/components/shared/ModalEstado.vue'
import ModalAutorizar from './components/ModalAutorizar.vue'
import Tb_Tickets from './Tb_Tickets.vue'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'SoporteSistemas',
  components: { Loader, NavBarSoporte, ModalEstado, Tb_Tickets, ModalAutorizar },
  data () {
    return {
      isLoading: true,
      areaStr: '',
      tickets: [],
      ticketsShow: [],
      ticketsShowOld: [],
      ticketSelect: '',
      modalStatus: false,
      modalStatusAut: false,
      configModal: {},
      queryFilter: '',
      queryUbicacion: 'ALL',
      isAdmin: false,
      showPendientes: false,
      actividadSelect: {}
    }
  },
  watch: {
    queryFilter() {
      if (this.queryFilter) {
        this.ticketsShow = this.tickets.filter(tick => {
          return `${tick.serie} ${tick.solicita} ${tick.resuelve} ${tick.equipo}`.toUpperCase().includes(this.queryFilter)
        })

      } else {
        this.ticketsShow = this.tickets
      }
    },
    queryUbicacion() {
      switch (this.queryUbicacion) {
        case 'ALL':
          this.ticketsShow = this.tickets
          break
        case 'TPA':
          this.ticketsShow = this.tickets.filter(tick => tick.ubicacion === 'TPA' || tick.ubicacion === 'EB00')
          break
        case 'IRGE':
          this.ticketsShow = this.tickets.filter(tick => tick.ubicacion === 'IRGE' || tick.ubicacion === 'ERM')
          break
        case 'EB04':
          this.ticketsShow = this.tickets.filter(tick => tick.ubicacion === 'EB04')
          break
        case 'CORP':
          this.ticketsShow = this.tickets.filter(tick => tick.ubicacion === 'CORP')
          break
        case 'LPGD':
          this.ticketsShow = this.tickets.filter(tick => tick.ubicacion === 'EB01' || tick.ubicacion === 'EB02' || tick.ubicacion === 'EB03' || tick.ubicacion === 'LPGD')
          break
      
        default:
          this.ticketsShow = this.tickets
          break
      }
    },
    showPendientes() {
      this.ticketsShowOld = this.ticketsShow

      if (this.showPendientes) {
        switch (parseInt(this.userLogin.categoria)) {
          case 0:
            this.ticketsShowOld = this.ticketsShow
            this.ticketsShow = this.tickets.filter( ticket => ticket.estado == 3)
            break
          case 2:
            this.ticketsShowOld = this.ticketsShow
            this.ticketsShow = this.tickets.filter( ticket => ticket.estado == 1 && parseInt(ticket.compra) == 1)
            break
          case 3:
            this.ticketsShowOld = this.ticketsShow
            this.ticketsShow = this.tickets.filter( ticket => ticket.estado == 0)
            break
        
          default:
            break
        }
        
      } else {
        this.ticketsShow = this.ticketsShowOld
        this.ticketsShowOld = []
      }
    }
  },
  methods: {
    iniciarComponente() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      }
      console.log(this.userLogin.cargo)
      switch (true) {
        case parseInt(this.userLogin.categoria) === 0 && this.userLogin.cargo === '000':
          this.isAdmin = true
          break

        case parseInt(this.userLogin.categoria) === 0 && this.userLogin.cargo === '003':
          this.isAdmin = true
          break
      
        case parseInt(this.userLogin.categoria) === 2 && parseInt(this.userLogin.departamento) === 1:
          this.isAdmin = true
          break

        case parseInt(this.userLogin.categoria) === 2 && parseInt(this.userLogin.departamento) === 3:
          this.isAdmin = true
          break

        default:
          this.isAdmin = false 
          break
      }

      if (this.area_soporte === 'I') {
        this.areaStr = 'Soporte Instrumentación y Control '
      } else {
        this.areaStr = 'Soporte Sistemas y Telec. '
      }
      this.obtenerTickets()
    },
    
    obtenerTickets () {
      switch (this.userLogin.categoria) {
        case 0:

          if (this.userLogin.cargo === '000' || this.userLogin.cargo === '003') {
            ticketServices.searchAll()
              .then((data) => {
                let ticketsConvert = data.map(this.convetirTickets)
                this.tickets = ticketsConvert
                this.ticketsShow = this.tickets
                this.isLoading = false
              })
              .catch((e)=> {
                console.error(e)
                this.isLoading = false
              })
          } else {
            ticketServices.searchTicket_user(this.userLogin.id, 's')
              .then((data) => {
                let ticketsConvert = data.map(this.convetirTickets)
                this.tickets = ticketsConvert
                this.ticketsShow = this.tickets
                this.isLoading = false
              })
              .catch((e)=> {
                console.error(e)
                this.isLoading = false
              })
          }
          break
        case 2:
          if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
            console.log('USER GIA')
            ticketServices.searchTicket_area(this.userLogin.departamento)
              .then((data) => {
                this.tickets = data.map(this.convetirTickets)
                this.ticketsShow = this.tickets
                this.isLoading = false
              })
              .catch((e)=> {
                console.error(e)
                this.isLoading = false
              })
          } else {
            console.log('USER OTRO DEP')
            ticketServices.searchTicket_user(this.userLogin.id, 's')
              .then((data) => {
                this.tickets = data.map(this.convetirTickets)
                this.ticketsShow = this.tickets
                this.isLoading = false
              })
              .catch((e)=> {
                console.error(e)
                this.isLoading = false
              })
          }
          break
        case 3:
          if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3 || this.userLogin.departamento === 6) {
            ticketServices.searchTicket_user(this.userLogin.id, 'a')
              .then((data) => {
                this.tickets = data.map(this.convetirTickets)
                this.ticketsShow = this.tickets
                this.isLoading = false
              })
              .catch((e)=> {
                this.displayToast(e.message, 'ban', 'OK')
                this.isLoading = false
              })
          } else {
            ticketServices.searchTicket_user(this.userLogin.id, 's')
              .then((data) => {
                this.tickets = data.map(this.convetirTickets)
                this.ticketsShow = this.tickets
                this.isLoading = false
              })
              .catch((e)=> {
                console.error(e)
                this.isLoading = false
              })
          }

          break

        default:
          ticketServices.searchTicket_user(this.userLogin.id, 's')
            .then((data) => {
              this.tickets = data.map(this.convetirTickets)
              this.ticketsShow = this.tickets
              this.isLoading = false
            })
            .catch((e)=> {
              console.log(e)
              this.isLoading = false
            })
          break
      }
    },
    
    convetirTickets(ticket) {
      return {
        ...ticket,
        area: parseInt(ticket.area),
        departamento: parseInt(ticket.departamento),
        diagnostico: parseInt(ticket.diagnostico),
        estado: parseInt(ticket.estado),
        id: parseInt(ticket.id),
        restante: parseInt(ticket.restante),
        compra: parseInt(ticket.compra),
        idResolucion: parseInt(ticket.idResolucion)
      }
    },
    
    checarModal (value) {
      console.log(value)
      this.modalStatus = false
      this.isLoading = true
      if (value !== 'close') {
        if (this.ticketSelect !== '') {
          let fechaRes = moment().format('YYYY-MM-DD HH:mm:ss')
          ticketServices.update_TicketResuelve(this.ticketSelect, this.userLogin.id, this.userLogin.usuario, value, fechaRes)
            .then( res => {
              if (res.success) {
                this.displayToast(res.respuesta, 'done', 'OK')
                this.obtenerTickets()
              } else {
                this.displayToast(res.respuesta, 'ban', 'OK')
              }
              this.isLoading = false
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast(e.message, 'ban', 'OK')
            })
        } else {
          console.error('Error no hay solicitud seleccionada ')
        }
      }
      this.isLoading = false
    },
    
    backPage() {
      this.$router.back()
    },
    
    showModalSolCompra(ticket) {
      this.ticketSelect = ticket.id

      if (this.userLogin.categoria === 0 && this.userLogin.departamento === 6) {
        this.modalStatusAut = true
      } else {
        this.modalStatusAut = true
        /*
        console.log('Here ✋') 
        this.configModal = {
          title: 'Comprar Equipo',
          content: `¿Aceptar compra de ${ticket.equipo}?`,
          textCancel: 'Rechazar',
          classOk: 'is-black',
          textOk: 'Comprar',
          classCancel: 'is-danger'
          }
        this.modalStatus = true*/
      }
    },
    checarModal(desicion) {
      if (desicion !== 'close') {
        let newEstado = 0
        this.userLogin.categoria === 2 && desicion ? newEstado = 3 : newEstado = 2

        ticketServices.update_EstadoTicket(this.ticketSelect, newEstado, this.userLogin.id, this.userLogin.nombre, 0)
          .then((data) => {
            if (data.success) {
              this.displayToast(data.respuesta, 'done', 'OK')
              this.obtenerTickets()
              this.showPendientes = false
            } else {
              this.displayToast(data.respuesta, 'ban', 'OK')
            }
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })

      }
      this.modalStatus = false
    },
    checarModalAutCompra (objModal) {
      console.log(objModal)
      this.modalStatusAut = false
      if (objModal.action !== 'close') {
        let newEstado = 0
        //this.userLogin.categoria === 0 && objModal.action ? newEstado = 5 : newEstado = 4
        this.userLogin.categoria === 2 && objModal.action ? newEstado = 5 : newEstado = 4
        ticketServices.update_EstadoTicket(this.ticketSelect, newEstado, this.userLogin.id, this.userLogin.nombre, objModal.tipoCompra)
          .then((data) => {
            if (data.success) {
              this.displayToast(data.respuesta, 'done', 'OK')
              this.obtenerTickets()
              this.showPendientes = false
            } else {
              this.displayToast(data.respuesta, 'ban', 'OK')
            }
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
      } 
      this.modalStatusAut = false
    },

    displayToast(text, icon, actionText) {
      let toast = this.$toasted.show(text, {
        theme: "toasted-black", 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    
    printReport(t) {
      this.isLoading = true
      const api_url = window.location.hostname
      const storage = '/var/www/html/reportesApp/'

      ReportesServices.getActividad(t.id_actividad)
        .then((data) => {
          this.actividadSelect = this.convertirActividad(data)
          console.log(this.actividadSelect)
          this.actividadSelect.evidencias = this.actividadSelect.evidencias.map(this.convetirEvidencias)

          let fRealiza = `${storage}${this.actividadSelect.usuario.avatar}`
          let fSupervisa = ''

          if (this.actividadSelect.estado > 1) {
            fSupervisa = `${storage}${this.actividadSelect.jefeArea.avatar}`
          } else {
            fSupervisa = `${storage}images/firmas/default.png`
          }

          let array_evidencias = [ 
            { id: 1, path: `${storage}images/firmas/default.png` }, 
            { id: 2, path: `${storage}images/firmas/default.png` }, 
            { id: 3, path: `${storage}images/firmas/default.png` }, 
            { id: 4, path: `${storage}images/firmas/default.png` }, 
            { id: 5, path: `${storage}images/firmas/default.png` }, 
            { id: 6, path: `${storage}images/firmas/default.png` }, 
            { id: 7, path: `${storage}images/firmas/default.png` }, 
            { id: 8, path: `${storage}images/firmas/default.png` }, 
            { id: 9, path: `${storage}images/firmas/default.png` }, 
            { id: 10, path: `${storage}images/firmas/default.png` }, 
            { id: 11, path: `${storage}images/firmas/default.png` }, 
            { id: 12, path: `${storage}images/firmas/default.png` }
          ]
          let index = 0
          this.actividadSelect.evidencias.map((evi) => {
            if (evi) {
              array_evidencias[index].path = evi.path
            }
            index++
          })

          let fechaRegistro = moment(this.actividadSelect.fecha_Reg).format('YYYY-MM-DD')
          console.log(this.actividadSelect.permisoBD)

          ReportesServices.getActualizaciones(t.id_actividad)
            .then((resp) => {
              let numUpdates = parseInt(resp.numActs)
              console.log(numUpdates)
              const linkI1 = `https://${api_url}/reportesApp/server/actividadesFile1.php?id=${t.id_actividad}&fRealiza=${fRealiza}&fSupervisa=${fSupervisa}`;
              const linkI2 = `https://${api_url}/reportesApp/server/actividadesFile2.php?id=${t.id_actividad}&fRealiza=${fRealiza}&fSupervisa=${fSupervisa}`;
              const linkI3 = `https://${api_url}/reportesApp/server/actividadesFile3.php?id=${t.id_actividad}&evidencia1=${array_evidencias[0].path}&evidencia2=${array_evidencias[1].path}&evidencia3=${array_evidencias[2].path}&evidencia4=${array_evidencias[3].path}&evidencia5=${array_evidencias[4].path}&evidencia6=${array_evidencias[5].path}&evidencia7=${array_evidencias[6].path}&evidencia8=${array_evidencias[7].path}&evidencia9=${array_evidencias[8].path}&evidencia10=${array_evidencias[9].path}&evidencia11=${array_evidencias[10].path}&evidencia12=${array_evidencias[11].path}&fRealiza=${fRealiza}&fSupervisa=${fSupervisa}`;
              const linkI4 = `https://${api_url}/reportesApp/server/actividadesFile4.php?id=${t.id_actividad}&fRealiza=${fRealiza}&fSupervisa=${fSupervisa}`;
              const linkR = `https://${api_url}/reportesApp/server/reporteActividadesAllP.php?idAct=${t.id_actividad}&ubicacion=${t.ubicacion}&fechaReg=${fechaRegistro}&permiso=${this.actividadSelect.permisoBD}&acts=${numUpdates}`;
              const linkB = `https://${api_url}/reportesApp/server/borrarFiles.php?idAct=${t.id_actividad}&ubicacion=${t.ubicacion}&fechaReg=${fechaRegistro}`;
              this.getReporte(linkI1, linkI2, linkI3, linkI4, linkR, linkB, numUpdates)  
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast(e.message, 'ban', 'OK')
            })
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast(e.message, 'ban', 'OK')
        })
    },
    
    convertirActividad( act) {
      const storage = '/var/www/html/reportesApp/'

      let permiso = ''
      if (act.permiso === 'N/A' || act.permiso === '') {
        permiso = ''
      } else {
        permiso = `${storage}${act.imagen_permiso}`
      }

      return {
        ...act,
        area: parseInt(act.area),
        estado: parseInt(act.estado),
        permisoBD: permiso
      }
    },

    convetirEvidencias(evi) {
      const storage = '/var/www/html/reportesApp/'
      let absolutePath = `${storage}${evi.ruta}`
      return {
        ...evi,
        path: absolutePath
      }
    },

    async getReporte(link1, link2, link3, link4, linkR, linkB, numUpdates) {
      
      try {
        const response1 = await fetch(link1)
        const data1 = await response1.json()
        console.log(data1)
        if (data1.success) {

          try {
            const response2 = await fetch(link2)
            const data2 = await response2.json()  
            console.log(data2)
            if (data2.success) {
              
              try {
                const response3 = await fetch(link3)
                const data3 = await response3.json()
                console.log(data3)  

                if (data3.success) {

                  if ( parseInt(numUpdates) > 0) {
                    try {
                        const response4 = await fetch(link4)
                        const data4 = await response4.json()
                        if (data4.success) {
                          open(linkR, '_blank')
                          setTimeout(() => {
                            fetch(linkB)
                              .then(resB => resB.json())
                              .then(dataB=> {
                                console.log(dataB)
                                this.isLoading = false
                              })
                          }, 2500)
                        } else {
                          this.displayToast(data4.respuesta, 'ban', 'OK')    
                          this.isLoading = false
                        }
                        
                      } catch (error) {
                        this.isLoading = false
                        this.displayToast(error, 'ban', 'OK')
                      }
                  } else {
                    open(linkR, '_blank')
                      setTimeout(() => {
                        fetch(linkB)
                          .then(resB => resB.json())
                          .then(dataB=> {
                            console.log(dataB)
                            this.isLoading = false
                          })
                      }, 2500)
                  }

                } else {
                  this.displayToast(data3.respuesta, 'ban', 'OK')    
                  this.isLoading = false
                }
              } catch (error) {
                this.isLoading = false
                this.displayToast(error, 'ban', 'OK')
              }

            } else {
              this.displayToast(data2.respuesta, 'ban', 'OK')  
              this.isLoading = false
            }

          } catch (error) {
            this.isLoading = false
            this.displayToast(error, 'ban', 'OK')
          }

        } else {
          this.displayToast(data1.respuesta, 'ban', 'OK')
          this.isLoading = false
        }

      } catch (error) {
        this.isLoading = false
        this.displayToast(error.message, 'ban', 'OK')
      }
    }
  },
  created () {
    this.iniciarComponente()
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'area_soporte'])
  },
  mounted() {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.modalStatus = false // how to hide any open modal?
      }
    })
  }
}
</script>

<style lang="css" scoped>
  .table-responsive {
    overflow-x: auto;
  }

  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/soporte_Componentes/Soporte.vue